import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { employeeService } from "../services/employee.service";


export const fetchEmployees = createAsyncThunk("fetchEmployees", async () => {
    return await employeeService.fetchEmployees();
});

export const employeesSlice = createSlice({
    name: "employees",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
    },
    reducers: {
        resetStateEmployees: (state) => {
            state.list.isLoading = false;
            state.list.isError = false;
            state.list.message = null;
            state.list.data = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchEmployees.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(fetchEmployees.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
        });
        builder.addCase(fetchEmployees.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload;
        });
    },
});

export const { resetStateEmployees } = employeesSlice.actions;

export default employeesSlice.reducer;